import { FavouriteItem } from "app/area/favourite-administration/form/types-store";
import { ComplexValue } from "app/infrastructure/ui/form/types";

export const addOwners = (favouriteItem: FavouriteItem, newOwners: ComplexValue<number>[]) => {
  const currentOwners = favouriteItem?.owners ?? [];
  return currentOwners.filter(
    owner => !newOwners?.some(newOwner => newOwner.value === owner.value)
  ) ?? [];
};
